<template>
    <iframe
        v-if="gameUrl"
        :src="gameUrl"
        allow="autoplay; fullscreen"
        allowfullscreen="true"
        webkitallowfullscreen="true"
        mozallowfullscreen="true"
    ></iframe>
</template>
<script>
import Vue from 'vue';

export default {
    name: 'redpipe-frame',
    props: {
        session: {
            required: true
        }
    },
    computed: {
        gameUrl() {
            if (!this.session || !this.session.gameDesktopUrl)
                return null;
            const separator = this.session.gameDesktopUrl.indexOf('?') >= 0 ? '&' : '?';
            const params = Vue.state.redpipe.frameParameters
                .get()
                .map(p => `${p.key}=${p.val}`)
                .join('&');
            return `${this.session.gameDesktopUrl}${separator}${params}&hideFullScreen=1`;
        }
    }
};
</script>
<style lang="scss">
</style>


// WEBPACK FOOTER //
// front/src/skins/bulmasite/components/common/redpipe/redpipe-frame.vue